(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pp-card-swatches"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.pp-card-swatch');
    if (!swatch || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const card = swatch.closest('.product-card-wrapper');
    const image = card && card.querySelector('.card__media img');
    if (!image || !swatch.dataset.ppImage) return;
    event.preventDefault();
    image.srcset = swatch.dataset.ppSrcset;
    image.src = swatch.dataset.ppImage;
    image.alt = swatch.getAttribute('aria-label');
    card.classList.add('pp-color-preview');
    card.querySelectorAll('.pp-card-swatch').forEach(item => item.removeAttribute('aria-current'));
    swatch.setAttribute('aria-current', 'true');
    card.querySelectorAll('.card__heading a').forEach(link => { link.href = swatch.href; });
    card.querySelectorAll('[data-product-url]').forEach(button => { button.dataset.productUrl = swatch.getAttribute('href'); });
    card.querySelector('.pp-card-swatches__status').textContent = swatch.dataset.ppColor;
  });
  } catch(e) { console.error(e); }
})();

})();
